// extracted by mini-css-extract-plugin
export default {"tableItems":"TableItem_tableItems__C1JMg","saveButton":"TableItem_saveButton__wt2Wg","modifyButton":"TableItem_modifyButton__DX9tz","deleteButton":"TableItem_deleteButton__f7f1a"};